import React from "react";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { map, filter, get, size, uniqBy } from "lodash";

import Grid from "@material-ui/core/Grid";

import SubMenuElement from "./SubMenuElement";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import { isAllowed } from "../../utils/users";

const styles = {
  menuItem: {
    cursor: "pointer",
    height: "40px",
    lineHeight: "40px",
    padding: "0px 20px",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  subMenuItem: {
    cursor: "pointer",
    height: "40px",
    lineHeight: "40px",
    padding: "0px 20px 0px 45px",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const SubMenuElementWithSubMenu = (props) => {
  const {
    history,
    item,
    classes,
    closeParent,
    solutionsAccess,
    userLevel,
    permissions
  } = props;

  const [open, setOpen] = React.useState(false);

  const openSubMenu = () => setOpen(!open);

  const handleClose = () => {
    closeParent();
  };

  const handleClick = (url) => {
    history.push(url);
    handleClose();
  };

  if (
    size(
      filter(
        item.subPages,
        (subPage) =>
          !get(subPage, ["restrict"]) ||
          get(solutionsAccess, [subPage.restrict, "allow"])
      )
    ) === 0
  ) {
    return null;
  }

  const categories = filter(
    uniqBy(
      map(get(item, ["subPages"]), (subPage) => get(subPage, ["category"]))
    ),
    (cat) =>
      size(
        filter(
          get(item, ["subPages"]),
          (subPage) =>
            get(subPage, ["category"]) === cat &&
            userLevel <= get(subPage, ["enabled"]) &&
            (!get(subPage, ["restrict"]) ||
              get(solutionsAccess, [get(subPage, ["restrict"]), "allow"]))
        )
      ) > 0
  );

  return (
    <Grid item>
      <Grid
        container
        className={classes.menuItem}
        alignItems="center"
        onClick={openSubMenu}
      >
        <Grid
          item
          style={{ display: "flex", alignItems: "center", width: "20px" }}
        >
          <img
            src={open ? images.arrowOpenBlack : images.arrowClosedBlack}
            width={open ? "10px" : "8px"}
            alt="arrow"
          />
        </Grid>
        <Grid item>{I18n.get(`sidebar_${item.name}`)}</Grid>
      </Grid>
      {open && (
        <Grid container direction="column">
          {map(categories, (cat, index) => (
            <React.Fragment key={index}>
              {map(
                filter(
                  get(item, ["subPages"]),
                  (subPage) =>
                    get(subPage, ["category"]) === cat &&
                    userLevel <= get(subPage, ["enabled"]) &&
                    (!get(subPage, ["restrict"]) ||
                      get(solutionsAccess, [
                        get(subPage, ["restrict"]),
                        "allow",
                      ])) &&
                      (!get(subPage, ["permission"]) ||
                      isAllowed(permissions, get(subPage, ["permission"])))
                ),
                (subPage, i) => (
                  <SubMenuElement
                    key={i}
                    subPage={subPage}
                    handleClick={handleClick}
                    closeParent={closeParent}
                  />
                )
              )}
            </React.Fragment>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

export default withRouter(withStyles(styles)(SubMenuElementWithSubMenu));
